export default "__VITE_ASSET__BrO2hqMP__"